import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, effect, inject, input, signal } from '@angular/core'
import { ThemeService } from '@ui-core/services/theme.service'

@Component({
    selector: 'app-logo',
    imports: [CommonModule],
    templateUrl: './logo.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class Logo {
    private themeService = inject(ThemeService)

    logoLight = input<string | null>(null)
    logoDark = input<string | null>(null)

    isDarkMode = signal(false)

    constructor() {
        effect(() => {
            const isDark = this.themeService.isDarkMode()
            this.isDarkMode.set(isDark)
        })
    }
}
